import { CalendarIcon, ListBulletIcon } from "@heroicons/react/20/solid";
import clsx from "clsx";

export type CalendarView = "month" | "day";

type Props = {
	view: CalendarView;
	onChange: (view: CalendarView) => void;
};

const options = [
	{ view: "month", label: "Monat", Icon: CalendarIcon },
	{ view: "day", label: "Tag", Icon: ListBulletIcon },
] as const;

export function ViewSwitch({ view, onChange }: Props) {
	return (
		<div role="group"
			 aria-label="Ansicht"
			 className="flex h-7 items-center gap-1 rounded-lg border border-gray-300 p-0.5">
			{options.map(({ view: optionView, label, Icon }) => (
				<button key={optionView}
						type="button"
						aria-label={label}
						title={label}
						aria-pressed={view === optionView}
						onClick={() => onChange(optionView)}
						className={clsx("flex h-full items-center rounded-md px-2",
							view === optionView ? "bg-gray-200 text-gray-900" : "text-gray-500")}>
					<Icon className="size-3.5" />
				</button>
			))}
		</div>
	);
}
